//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import { savecrudCateApi, delcrudCateApi } from '@/api/develop';
export default {
  name: 'CrmebOaEntApplicatDialog',
  components: {
    draggable: draggable
  },
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      show: false,
      fromItem: []
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.show = false;
    },
    openBox: function openBox(list) {
      if (list.length == 0) {
        var item = {
          name: '',
          id: 0,
          sort: 0
        };
        this.fromItem.push(item);
      } else {
        this.fromItem = list;
      }
      this.show = true;
    },
    // 新增应用
    handleAddType: function handleAddType() {
      var _this = this;
      var item = {
        name: '',
        id: 0,
        sort: 0
      };
      this.fromItem.push(item);
      this.$nextTick(function () {
        var scrollTarget = _this.$refs.scrollTarget;
        var height = scrollTarget.scrollHeight;
        // 滚动到底部
        scrollTarget.scrollTo({
          top: height,
          behavior: 'smooth'
        });
      });
    },
    submit: function submit() {
      var _this2 = this;
      this.fromItem.forEach(function (item, index) {
        item.sort = _this2.fromItem.length - index;
      });
      var data = {
        cate: this.fromItem
      };
      savecrudCateApi(data).then(function (res) {
        _this2.handleClose();
        _this2.$emit('getList');
      }).catch(function (err) {
        _this2.$message.error(err.message);
      });
    },
    onStart: function onStart() {},
    onEnd: function onEnd() {},
    // 删除动态表单
    handleDelete: function handleDelete(item, index) {
      var _this3 = this;
      if (item.name == '') {
        this.fromItem.splice(index, 1);
        return false;
      }
      this.$modalSure('您确定要删除此实体分类吗').then(function () {
        if (item.id > 0) {
          delcrudCateApi(item.id).then(function (res) {
            _this3.fromItem.splice(index, 1);
            _this3.$emit('getList');
          });
        } else {
          _this3.fromItem.splice(index, 1);
        }
      });
    }
  }
};